import { createContext } from 'react';

export type VoidTransactionCtx = {
  showVoidTransactionConfirmAlert: boolean;
  showVoidTransactionErrorAlert: boolean;
  sendVoidTransactionError: string;
};

const VoidTransactionDialogueContext = createContext<VoidTransactionCtx>({
  showVoidTransactionConfirmAlert: false,
  showVoidTransactionErrorAlert: false,
  sendVoidTransactionError: '',
});

export default VoidTransactionDialogueContext;
